// extracted by mini-css-extract-plugin
export var backToResultsButton = "TileGrid-module--back-to-results-button--aYcp-";
export var button = "TileGrid-module--button--QtW3u";
export var dealGrid = "TileGrid-module--deal-grid--BHL1r";
export var dealGridContainer = "TileGrid-module--deal-grid-container--xTpxt";
export var pageSliceHeader = "TileGrid-module--page-slice-header--FV8tD";
export var primary = "#06004d";
export var secondary = "#4dafd7";